const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/outages/map"],
    exact: true,
    component: "OutageMap",
  },
  {
    path: ["/outages/list"],
    exact: true,
    component: "OutageList",
  },
  {
    path: ["/outages/list/:areaName"],
    exact: true,
    component: "OutageList",
  },
  {
    path: ["/outages/map/:areaName"],
    exact: true,
    component: "OutageMap",
  },
  {
    path: ["/areas"],
    exact: true,
    component: "AreasDirectory",
  },
  {
    path: ["/areas/:areaName"],
    exact: true,
    component: "AreaDetail",
  },
  {
    path: ["/outages/region/:areaName"],
    exact: true,
    component: "RegionRedirect",
  },
  {
    path: ["/power-tips"],
    exact: true,
    component: "PowerTips",
  },
  {
    path: ["/power-tips/blog/:id"],
    exact: true,
    component: "BlogView",
  },
  // COMMENTED OUT: Profile route disabled
  // {
  //   path: ["/profile"],
  //   exact: true,
  //   component: "Profile",
  // },
  {
    path: ["/blog/kplc-scheduled-outages"],
    exact: true,
    component: "OutageBlogs",
  },
  {
    path: ["/blog/kplc-scheduled-outages/:blogId"],
    exact: true,
    component: "OutageBlogs",
  },
  {
    path: ["/about"],
    exact: true,
    component: "About",
  },
  {
    path: ["/support"],
    exact: true,
    component: "ContactUs",
  },
  // {
  //   path: ["/analytics-example"],
  //   exact: true,
  //   component: "AnalyticsExample",
  // },
];

export default routes;
